import type { IconName } from '@/components/Icon';

/**
 * Иконка раздела прав. Ключ — заголовок группы из реестра Orchid
 * (PlatformProvider::permissions()); незнакомые группы получают замок, чтобы
 * новое право, добавленное в старой админке, не ломало вёрстку.
 */
export const GROUP_ICONS: Record<string, IconName> = {
  Система: 'settings',
  System: 'settings',
  'Клиенты куратора': 'user',
  'Все клиенты': 'users',
  Маркетинг: 'megaphone',
  Администрирование: 'shield',
};
